import { createSlice, PayloadAction, createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

interface MallsState {
  selectedMallId: string | null;
  ui: {
    isMallSelectorOpen: boolean;
  };
}

const initialState: MallsState = {
  selectedMallId: null,
  ui: {
    isMallSelectorOpen: false,
  },
};

const mallsSlice = createSlice({
  name: "malls",
  initialState,
  reducers: {
    setSelectedMall: (state, action: PayloadAction<string | null>) => {
      state.selectedMallId = action.payload;
    },

    clearSelectedMall: (state) => {
      state.selectedMallId = null;
    },

    openMallSelector: (state) => {
      state.ui.isMallSelectorOpen = true;
    },

    closeMallSelector: (state) => {
      state.ui.isMallSelectorOpen = false;
    },
  },
});

export const {
  setSelectedMall,
  clearSelectedMall,
  openMallSelector,
  closeMallSelector,
} = mallsSlice.actions;

// Base selector
const selectMallsState = (state: RootState) => state.malls;

// Memoized selectors
export const selectSelectedMallId = createSelector(
  [selectMallsState],
  (state) => state.selectedMallId
);

export const selectIsMallSelectorOpen = createSelector(
  [selectMallsState],
  (state) => state.ui.isMallSelectorOpen
);

export const selectMallsUI = createSelector(
  [selectMallsState],
  (state) => state.ui
);

export default mallsSlice.reducer;
